import { useNavigate } from "react-router-dom";
import { TFunction } from "i18next";

import { Badge, Button, Text } from "@pentabd/ui";
import { NotificationType } from "@type/notifications/notifications";
import { useLanguage } from "@hooks/useLanguage";

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { updateViewStatus } from "@api/notifications/notifications";
import { HeartBit } from "@components";

dayjs.extend(relativeTime);

export const TableColumn = (
  t: TFunction<"translation", undefined>,
  setIsErrorModalOpen: any,
) => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  return [
    {
      id: 1,
      key: "title",
      name: t("NOTIFICATIONS.TABLE.COLUMNS.NOTIFICATIONS"),
      render: (_: string, row: NotificationType) => {
        const date = dayjs(row.createdAt).fromNow();
        return (
          <div>
            <div className="d-flex align-items-center">
              <Text size="sm" className="text-subtitle2 d-block">
                {row.title}
              </Text>
              <div
                style={{
                  width: "6px",
                  height: "6px",
                  lineHeight: "6px",
                  borderRadius: "50%",
                  backgroundColor: "#D9D9D9",
                  margin: "0 10px",
                }}
              ></div>
              <Text size="sm" className="text-subtitle3 d-block">
                {date}
              </Text>
              <div
                style={{
                  width: "6px",
                  height: "6px",
                  lineHeight: "6px",
                  borderRadius: "50%",
                  backgroundColor: "#D9D9D9",
                  margin: "0 10px",
                }}
              ></div>
              <Badge
                type="success"
                size="sm"
                label={language === "en" ? row.moduleName : row.moduleNameBn}
              />
              {!row.isRead && (
                <div
                  style={{
                    margin: "0 10px",
                  }}
                >
                  <HeartBit />
                </div>
              )}
            </div>
            <Text className="mt-3 text-info-semi-middark d-block" weight="bold">
              {row.message}
            </Text>
          </div>
        );
      },
    },
    {
      id: 2,
      key: "redirectUrl",
      name: t("NOTIFICATIONS.TABLE.COLUMNS.ACTION"),
      render: (redirectUrl: string, row: any) => {
        const url = new URL(redirectUrl);
        const pathname = url?.pathname;

        const handleRedirect = async () => {
          try {
            await updateViewStatus(row.id);
            navigate(`${pathname}${url?.search || "/"}`);
          } catch (error) {
            setIsErrorModalOpen(true);
          }
        };

        return redirectUrl ? (
          <Button
            fill="fill"
            className="bg-info-lighter text-info-semi-middark"
            size="sm"
            onClick={handleRedirect}
          >
            View
          </Button>
        ) : (
          <></>
        );
      },
    },
  ];
};
